import Box16 from '@carbon/icons-react/es/box/16';
import { Col, Space, Typography } from 'antd';
import React, { FC, useState } from 'react';
import { ArchiveProjectModal } from 'components/molecules/project-actions-modal';
import { useCurrentProject } from 'hooks/use-current-project';
import { useTranslation } from 'hooks/use-translation';
import { CTASectionRow, SectionTitle, StyledButton } from './styles';

const { Text } = Typography;

export const ArchiveProjectControl: FC = () => {
  const projectDetails = useCurrentProject();
  const [showArchiveModal, setShowArchiveModal] = useState<boolean>(false);

  const archiveTitle = useTranslation('project.action.archive.title');
  const archiveMessage = useTranslation('project.action.archive.content');
  const archiveButtonText = useTranslation('archive');
  const closeArchiveModal = () => {
    setShowArchiveModal(false);
  };

  return (
    <CTASectionRow>
      <Col>
        <Space direction="vertical" size="middle">
          <SectionTitle>{archiveTitle}</SectionTitle>
          <Text>{archiveMessage}</Text>
          <StyledButton
            type="primary"
            data-test-id="project.action.archive.btn"
            ghost
            icon={<Box16 />}
            iconPlacement="right"
            onClick={() => setShowArchiveModal(true)}
          >
            {archiveButtonText}
          </StyledButton>

          <ArchiveProjectModal
            isVisible={showArchiveModal}
            projectId={projectDetails.projectId}
            projectName={projectDetails.projectName}
            closeModal={closeArchiveModal}
          />
        </Space>
      </Col>
    </CTASectionRow>
  );
};
